import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnChanges, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IFieldSpecs } from 'libraries/module/formbuilder/fields/interfaces/field-specs';
import { TextComponent } from 'libraries/module/formbuilder/fields/text/text.component';
import { ICoordsTable } from "libraries/service/table-keyboard-navigation/table-keyboard-navigation.service";

@Component({
    selector: 'block-title-editor',
    template: `
        <text #textField [fieldConfig]="fieldConfig" (keyup.enter)="blur()" class="no-border"></text>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class BlockTitleEditorComponent implements OnChanges {

    @Input()
    public fieldConfig: IFieldSpecs;

    /**
     * Indicate that Edition is opened from keyboard navigation  in parent component
     */
    @Input()
    public isKeyboardOpen: boolean;

    @Output()
    public readonly onFocusField: EventEmitter<ICoordsTable> = new EventEmitter<ICoordsTable>();

    @ViewChild('textField')
    public readonly textField: TextComponent;

    public ngOnChanges(changes: SimpleChanges): void {
        if(changes.isKeyboardOpen && changes.isKeyboardOpen.currentValue){
            setTimeout(()=>{
                this.textField.focusInput();
            });
        }
    }

    public blur(): void {
        setTimeout(()=>{
            this.textField.blurInput();
        });
    }
}
